module.exports = __webpack_public_path__ + "static/media/arrows-alt-h.848175a9.svg";